// extracted by mini-css-extract-plugin
export default {"card":"f5-z"};